<template>
  <div
    id="dadiankey"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        :data="tableData"
        @sort-change="sortChange"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed
          align="center"
          type="index"
          label="排序"
          width="50"
        >
        </el-table-column>
        <!-- <el-table-column
          align="center"
          min-width="170"
          prop="card_number"
          label="来源"
        >
          <template slot-scope="v">
            <p>{{ v.row.class }} - {{ v.row.key }} - {{ v.row.other }}</p>
          </template>
        </el-table-column> -->
        <el-table-column align="center" prop="class" label="一级">
        </el-table-column>
        <el-table-column align="center" prop="key" label="二级">
        </el-table-column>
        <el-table-column align="center" prop="other" label="三级">
        </el-table-column>
        <el-table-column align="center" prop="name" label="备注">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="v">
            <p class="addstyle" @click="addname(v.row)">
              {{ v.row.name == "" ? "添加" : "修改" }}备注
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>

    <el-dialog title="备注" :visible.sync="addnameshow" width="30%" center>
      <div class="daley">
        <el-input placeholder="请输入备注" v-model="shename" clearable>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addnameshowclick('no')">取 消</el-button>
        <el-button type="primary" @click="addnameshowclick('yes')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import buttonSearch from "@/components/common/button-search.vue";
export default {
  components: {
    buttonSearch,
  },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      createModel: false,
      editIndex: -1,
      //搜索数据
      from: {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
      },
      model_title: "Host",
      auth_val: "Mtlog",
      preUrl: "data/dadiankeyList", //列表地址

      tableData: [],
      form: {
        id: 0,
        remark: "",
      },
      prop: "",
      sort: "descending",
      rules: {
        remark: [
          {
            required: true,
            message: "请输入拒绝原因",
            trigger: "blur",
          },
        ],
      },
      rule_list: [],
      check_img_list: [],
      cz_money: 0,
      tx_money: 0,

      anchordetails: false,
      looklistdata: [],
      pagetwo: {
        current: 1,
        sizes: [10, 20, 50, 100],
        size: 10,
        total: 0,
      },
      addnameshow: false,
      shename: "",
      shenameid: "",
    };
  },
  watch: {},
  created() {
    //this.commonList('rule');
  },
  methods: {
    sortChange(column) {
      this.prop = column.prop;
      this.sort = column.order;
      this.getList();
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },

    getListResult(e) {
      this.tableData = e.list;
      this.cz_money = e.cz_money;
      this.tx_money = e.tx_money;
      this.check_img_list = e.list.map((item) => {
        return item.head;
      });
    },
    addname(tiem) {
      this.addnameshow = true;
      this.shename = tiem.name;
      this.shenameid = tiem.id;
    },
    addnameshowclick(value) {
      if (value == "no") {
        this.addnameshow = false;
        this.shename = "";
        this.shenameid = "";
      } else {
        if (this.shename != "" && this.shenameid != "") {
          this.api
            .post(
              "/data/editDadiankey",
              {
                id: this.shenameid,
                name: this.shename,
              }
            )
            .then((res) => {
              this.shename = "";
              this.shenameid = "";
              this.addnameshow = false;
              this.$message("提交成功！");
              this.getList();
            })
            .catch((err) => {});
        } else {
          this.$message({
            message: "请正确填写！",
            type: "warning",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.listhnn {
  cursor: pointer;
}
::v-deep .el-dialog__headerbtn {
  outline: none;
}
.addstyle {
  cursor: pointer;
  margin: 10px 0;
}
.addstyle:hover{
  color: #008080;
}
.daley {
  width: 80%;
  margin: 0 auto;
  padding: 10px 0;
}
</style>
